export default {
  hidden_rates:
    'Niektóre metody płatności mają też własną stawkę, ustawioną przez pomoc techniczną Twojej platformy. Obowiązuje ona zamiast tej stawki.',
  title: 'Opłaty za przetwarzanie',
  subtitle: 'Opłata za przetwarzanie naliczana restauracji {{company}} od płatności online, pokrywająca opłaty Stripe.',
  card_title: 'Opłata za przetwarzanie',
  status: {
    inherited_tag: 'Domyślna partnera',
    inherited: 'Ta restauracja płaci Twoją domyślną opłatę za przetwarzanie.',
    custom_tag: 'Własna',
    custom: 'Ta restauracja ma własną prowizję za przetwarzanie płatności, która zastępuje domyślną.',
    none_title: 'Nie ustawiono opłaty za przetwarzanie',
    none: 'Ani ta restauracja, ani Twoja wartość domyślna nie mają stawki. Jeśli nie potwierdzono 0% marży na stronie prowizji partnera za przetwarzanie, restauracja nie może zostać uruchomiona ani przyjmować płatności online; po takim potwierdzeniu nie jest obciążana żadną prowizją, a Ty pokrywasz prowizje Stripe od jej płatności.',
  },
  buttons: {
    set_custom: 'Ustaw własną opłatę',
    edit: 'Edytuj',
    cancel: 'Anuluj',
    save: 'Zapisz',
    reset_to_default: 'Przywróć domyślną',
  },
  toasts: {
    load_error: 'Nie udało się wczytać opłaty za przetwarzanie.',
    failed_to_save_changes: 'Nie udało się zapisać opłaty za przetwarzanie.',
    changes_got_saved: 'Opłata za przetwarzanie zapisana',
    reset_to_default: 'Ta restauracja korzysta teraz z Twojej domyślnej opłaty za przetwarzanie.',
  },
};
